import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.function.name.js";
import { useGetSharingPermissions } from 'screens/ShareModal';
export function useGetContentShareData(_ref) {
  var items = _ref.items,
    parentPlaylistId = _ref.parentPlaylistId;
  var onlyAssetsSelected = items.every(function (item) {
    return item.type !== 'playlist' && item.type !== 'section';
  });
  var onlyPlaylistsSelected = items.every(function (item) {
    return item.type === 'playlist';
  });
  var canShareContent = onlyAssetsSelected || onlyPlaylistsSelected;
  var _useGetSharingPermiss = useGetSharingPermissions({
      contentIds: items.map(function (item) {
        return item.id;
      }),
      name: items.length === 1 ? items[0].name : undefined,
      contentParentPlaylistId: parentPlaylistId,
      playlistsToShare: onlyPlaylistsSelected ? items : undefined
    }),
    shareData = _useGetSharingPermiss.shareData,
    isLoading = _useGetSharingPermiss.isLoading;
  if (isLoading || !shareData || !canShareContent) {
    return null;
  }
  return shareData;
}
export default useGetContentShareData;